import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material';
import {RicambiService} from '../service/ricambi.service';
import {Ricambio} from '../models/ricambio';
import {Categoria} from '../models/categoria';
import {UserService} from '../service/user.service';
import {Carrello} from '../models/carrello';
import {TwsCategoriaComponent} from '../tws-categoria/tws-categoria.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import 'rxjs/add/operator/switchMap';


@Component({
    selector: 'app-tws-ricambi',
    templateUrl: './tws-ricambi.component.html',
    styleUrls: ['./tws-ricambi.component.css']
})
export class TwsRicambiComponent implements OnInit {
    @ViewChild(TwsCategoriaComponent) private categorieComponent: TwsCategoriaComponent;
    ricerca: boolean = false;
    categoriaCorrente: Categoria = new Categoria(0, "", "", 0);
    lastCategoria: any;
    risultati: boolean = false;
    tipiRicambi: Array<any>;//da ricerca
    ricambi: Array<Ricambio> = new Array<Ricambio>();//in teoria ho l'albero e posso metterlo in cache
    codice: string;
    descrizione: string;
    constructor(private ricambiService: RicambiService, private userService: UserService, public snackBar: MatSnackBar, private route: ActivatedRoute, private location: Location, private router: Router) {

    }

    ngDoCheck() {
        let idCategoria = +this.route.snapshot.params['id'];
        if (idCategoria) {
            if (idCategoria != this.lastCategoria) {
                this.lastCategoria = idCategoria;
                this.ngOnInit();
            }
        }
    }

    ngOnInit() {
        console.log("init");
        //tanto dovrebbe essere cache
        this.reset();
        let idCategoria = +this.route.snapshot.params['id'];
        if (idCategoria) {
            this.lastCategoria = idCategoria;
            this.ricambiService.getCategorieRicambi().then(heroes => {
                this.tipiRicambi = heroes;
                let categoria: Categoria[] = heroes.filter(categoria => categoria.id == idCategoria);
                this.categoriaCorrente = categoria[0];
                this.onRouteCategoria(this.categoriaCorrente);
            });
        } else {//parto da 0
            this.ricambiService.getCategorieRicambi().then(mac => this.tipiRicambi = mac);
            if (!this.risultati) {

                this.caricataCategoria(this.categoriaCorrente);
            }
        }
    }

    reset(): void {

        this.categoriaCorrente = new Categoria(0, "", "", 0);
        this.ricerca = false;
        this.toggle = false;
        this.ricerca = false;
        this.risultati = false;
        this.toggle = false;
        this.descrizione = "";
        this.codice = "";
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
    }
    caricataCategoria(hero: Categoria): void {
        this.categoriaCorrente = hero;
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
    }
    
     onSelectCategoria(hero: Categoria): void {
        this.codice = "";
        this.router.navigate(['/ricambi', hero.id]);
    }

    onRouteCategoria(hero: Categoria): void {
        this.categoriaCorrente = hero;
        this.caricataCategoria(hero);
        this.ricambiService.getRicambi(this.categoriaCorrente.id).then(mac => this.risultatiRicerca(mac));
        this.ricerca = false;
        this.codice = "";
        this.descrizione = "";

    }

    cercaRicambi(): void {
        this.ricerca = true;
        this.risultati = true;
        this.toggle = false;
        this.categoriaCorrente = new Categoria(0, "", "", 0);
        this.ricambiService.cercaRicambi(this.codice, this.descrizione).then(mac => this.risultatiRicerca(mac));

    }

    risultatiRicerca(mac: Ricambio[]): void {
        this.ricerca = false;
        this.ricambi = mac;
        this.risultati = true;
    }
    aggiungiCarrello(ricambio: Ricambio): void {
        let qta = 1;
        if (ricambio.qta && ricambio.qta > 1) {
            qta = ricambio.qta;
        }
        this.ricambiService.aggiungiCarrello(ricambio.id, qta).then(carrello => this.aggiunto(carrello));

    }

    aggiunto(carrello: Carrello) {
        this.snackBar.open(RicambiService.traduci("Prodotto aggiunto al carrello"), "", {duration: 2000});
    }

    get utente(): any {
        return this.userService.getProfilo();
    }
    toggle: boolean = false;
    clickToggle(): void {
        this.toggle = !this.toggle;
    }
}



// WEBPACK FOOTER //
// ./src/app/tws-ricambi/tws-ricambi.component.ts